import moment from 'moment';

import { Organization } from '../types';
import { ensureDateIsUTC } from './formatting/ensureDateIsUTC';

export const DISABLED_LICENSE_EXPIRATION_DATE = '0000-00-00 00:00:00';

export const checkIsLicenseExpirationActive = (
    organization: Organization | null | undefined
): boolean => {
    if (!organization?.licensed_until) {
        return false;
    }

    return organization.licensed_until !== DISABLED_LICENSE_EXPIRATION_DATE;
};

export const checkIsLicenseExpired = (organization: Organization | null | undefined): boolean => {
    if (checkIsLicenseExpirationActive(organization)) {
        return moment(ensureDateIsUTC(organization.licensed_until)).isBefore(moment());
    }
    return false;
};

export const getDaysUntilDateFromNow = (dateStr: string | undefined): number => {
    if (!dateStr || dateStr === DISABLED_LICENSE_EXPIRATION_DATE) {
        return 0;
    }
    return moment(ensureDateIsUTC(dateStr)).diff(moment(), 'days');
};
